<template>
  <forgerock-template id="post-login-page" container-class="container login-container">

    <div class="container-xxl d-flex align-content-center min-h480">
      <div class="row align-self-center">
        <h2 id="title title-dash">{{ $t('SUI.page.postLogin.title') }}</h2>
        <h5>{{ $t('SUI.page.postLogin.summary') }}</h5>
        <p class="error-details">{{ $t('SUI.page.postLogin.details') }}</p>
        <slot/>
      </div>
    </div>

  </forgerock-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ForgerockTemplate from '@/components/layout/ForgerockTemplate.vue';

export default defineComponent({
  name: 'PostLoginPage',
  components: { ForgerockTemplate },
});
</script>

<style scoped>
.min-h480 {
  min-height: 480px;
}
</style>
